import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import { color } from 'styles/colors'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'

type Props = {
  onDateChangeCallback: (string) => void,
  date: string,
  minDate?: moment.Moment | null,
  maxDate?: moment.Moment | null,
  variant?: 'textOnly' | null,
  showCalendarIcon?: boolean,
  rightAlign?: boolean
}
const DEFAULT_MAX_DATE = moment()

const Calendar = ({
  onDateChangeCallback,
  minDate,
  maxDate = DEFAULT_MAX_DATE,
  date,
  variant,
  showCalendarIcon = false,
  rightAlign = false
}: Props) => {
  const [showDateCalendar, setShowDateCalendar] = useState(false)

  return (
    <S.Calendar>
      <Button decoration={variant || 'secondary'} aria-label="calendar" onPress={() => setShowDateCalendar(!showDateCalendar)}>
        <S.CalendarIcon>
          {showCalendarIcon && <i className="icon-calendar" />}
          <S.Caret className="icon-caret-down" />
        </S.CalendarIcon>
      </Button>

      {showDateCalendar &&
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <S.DateCalendar
            showDaysOutsideCurrentMonth
            views={['day']}
            minDate={moment(minDate)}
            maxDate={moment(maxDate)}
            value={moment(date)}
            onChange={(date: moment.Moment) => {
              onDateChangeCallback(date.format('YYYY-MM-DD'))
              setShowDateCalendar(false)
            }}
            rightAlign={rightAlign}
          />
        </LocalizationProvider>
      }
    </S.Calendar>
  )
}

export default Calendar

const S = {
  Calendar: styled.div`
    position: relative;
  `,
  CalendarIcon: styled.div`
    font-size: 21px;
    text-align: center;
    color: ${color('cancelButtonText')};

    &:hover {
      color: ${color('cancelButtonHoverText')};
    }

    &:active {
      color: ${color('alertLookupButtonHover')};
    }
  `,
  Caret: styled.i`
    margin-left: 10px;
  `,
  DateCalendar: styled(DateCalendar).withConfig({
    shouldForwardProp: (prop) => !['rightAlign'].includes(prop)
  })<{ rightAlign: boolean | null }>`
    position: absolute;
    z-index: 1;
    border: 1px solid ${color('shadowLight')};
    box-shadow: 0 5px 10px ${color('shadowLight')};
    background: ${color('paneBackground')};
    ${({ rightAlign }) => rightAlign ? 'right: 0px' : ''};
  `
}
